import React from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Box from "@mui/material/Box";
import ComposeIcon from "@mui/icons-material/Create";
import DraftsIcon from "@mui/icons-material/Drafts";
import EmailIcon from "@mui/icons-material/Email";
import SentIcon from "@mui/icons-material/Send";
import { FaRegStar } from "react-icons/fa";
import { FaStar } from "react-icons/fa";
import { connect } from "react-redux";
import { postAPIMessage, postAPIMessages } from "./../redux/actions";
import { useHistory } from "react-router-dom";

const ViewSelector = (props) => {
  const history = useHistory();
  return (
    <div>
      {props.getAPIMailboxes.length > 0 ? (
        <Box>
          <Select
            variant="standard"
            labelId="demo-simple-select-outlined-label"
            id="demo-simple-select-outlined"
            labelwidth={200}
            value={props.getAPIMailbox}
            onChange={(e) => {
              history.push("/" + e.target.value + "/inbox");
            }}
            style={{
              marginLeft: "15px",
              width: "89%"
            }}
          >
            {props.getAPIMailboxes.map((x) => (
              <MenuItem key={x} value={x}>
                <div className="d-flex align-items-center justify-content-start">
                  {props.favoriteEmail === x ? (
                    <FaStar size={15} color="orange" className="me-2 " />
                  ) : (
                    <FaRegStar
                      size={15}
                      className="me-2 "
                      color="lightgray"
                      onClick={(e) => props.onStarIconClick(e, x)}
                    />
                  )}

                  <span className="fs-6">{x}</span>
                </div>
              </MenuItem>
            ))}
          </Select>
        </Box>
      ) : (
        ""
      )}
      <List component="nav" aria-label="main mailbox folders">
        {props.getAPIEmployee && (
          <ListItem
            button
            style={{
              backgroundColor: props.action === "Compose" ? "lightgray" : ""
            }}
            onClick={() => {
              props.postAPIMessage(null);
              history.push("/" + props.getAPIMailbox + "/compose");
            }}
          >
            <ListItemIcon>
              <ComposeIcon />
            </ListItemIcon>
            <ListItemText primary={"Compose"} />
          </ListItem>
        )}
        {!props.getAPIEmployee && (
          <ListItem
            button
            style={{
              backgroundColor: props.action === "Compose" ? "lightgray" : ""
            }}
            onClick={() => {
              props.postAPIMessage(null);
              history.push("/" + props.getAPIMailbox + "/contactus");
            }}
          >
            <ListItemIcon>
              <ComposeIcon />
            </ListItemIcon>
            <ListItemText primary={"Contact Us"} />
          </ListItem>
        )}
        <ListItem
          button
          style={{
            backgroundColor: props.action === "Received" ? "lightgray" : ""
          }}
          onClick={() => {
            history.push("/" + props.getAPIMailbox + "/inbox");
          }}
        >
          <ListItemIcon>
            <EmailIcon />
          </ListItemIcon>
          <ListItemText
            primary={
              "Inbox(" +
              props.getAPIMessages?.filter(
                (x) => x.status === "Received" && !x.read
              ).length +
              ")"
            }
          />
        </ListItem>
        <ListItem
          button
          style={{
            backgroundColor: props.action === "Drafts" ? "lightgray" : ""
          }}
          onClick={() => {
            props.postAPIMessage(null);
            history.push("/" + props.getAPIMailbox + "/drafts");
          }}
        >
          <ListItemIcon>
            <DraftsIcon />
          </ListItemIcon>
          <ListItemText
            primary={`Drafts(${
              props.getUserSettingsLocalDrafts.filter((x) => x !== null).length
            })`}
          />
        </ListItem>
        <ListItem
          button
          style={{
            backgroundColor: props.action === "Sent" ? "lightgray" : ""
          }}
          onClick={() => {
            history.push("/" + props.getAPIMailbox + "/sent");
          }}
        >
          <ListItemIcon>
            <SentIcon />
          </ListItemIcon>
          <ListItemText primary="Sent" />
        </ListItem>
      </List>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    getAPIMessages: state.API.Messages,
    getAPIMailbox: state.API.Mailbox,
    getAPIEmployee: state.API.Employee,
    getAPIMailboxes: state.API.Mailboxes,
    getUserSettingsLocalDrafts: state.User.Settings.Local.Drafts
  };
}

const mapDispatchToProps = {
  postAPIMessage,
  postAPIMessages
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewSelector);
